import "dayjs/locale/es";

import dayjs from "dayjs";

const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatDate = (date?: string) => {
  const formattedDate = dayjs(date ?? "")
    .locale("es")
    .format("DD MMMM YYYY");
  const month = formattedDate.split(" ")[1];
  const capitalizedMonth = capitalize(month);
  return formattedDate.replace(month, capitalizedMonth);
};
